import React from 'react'

export const Close = ({ fill, className }) => {
    return (

        <svg xmlns="http://www.w3.org/2000/svg" className={className} width="25" height="25" viewBox="0 0 17.481 17.48" fill={fill ? fill : '#bdbdbd'}>
            <path id="close" data-name="close" d="M10.342,8.876l6.807-6.807a1.132,1.132,0,0,0-1.6-1.6L8.74,7.275,1.934.468a1.132,1.132,0,0,0-1.6,1.6L7.139,8.876.332,15.683a1.132,1.132,0,1,0,1.6,1.6L8.74,10.478l6.807,6.807a1.132,1.132,0,1,0,1.6-1.6Zm0,0" transform="translate(0 -0.136)" />
        </svg>
    )
}